export default __webpack_public_path__ + "static/media/1.713a7ab8.jpg";